module.exports = __webpack_public_path__ + "static/media/lamp-trans-sm.33d616b5.jpg";